<script setup lang="ts">
import type { Product } from '~/types/shopware'
const { addProduct } = useCart()
const { pushSuccess } = useNotifications()
const { codeErrorsNotification } = useCartNotification()
const { t } = useI18n()
const { open } = useCartModal()

const props = defineProps<{
  product: Product
  label?: string
}>()

const onClick = () => {
  addProduct({
    id: props.product.id,
    quantity: 1,
  })
  codeErrorsNotification()
  pushSuccess(`${props.product?.translated?.name} ${t('shop.cartPage.hasBeenAddedToTheCart')}`)
  open()
}
</script>
<template>
  <Button primary icon="cart" :aria-label="label" @click.stop="onClick">
    {{ label }}
  </Button>
</template>
